import { render } from "./PageEdit.vue?vue&type=template&id=4512c428&ts=true"
import script from "./PageEdit.vue?vue&type=script&lang=ts"
export * from "./PageEdit.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__